import { Link } from "react-router-dom";
import styles from "./FinalCTA.module.css";

export default function FinalCTA() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.h2}>
          Your next great hire
          <br />
          is already here.
        </h2>
        <p className={styles.sub}>
          Skip the noise. Meet pre-vetted, AI-matched talent across Africa in
          minutes.
        </p>
        <div className={styles.btns}>
          <Link
            to="/register"
            className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}
          >
            Get Started →
          </Link>
          <Link
            to="/login"
            className={`${styles.btn} ${styles.btnOutline} ${styles.btnLg}`}
          >
            Find Talent
          </Link>
        </div>
      </div>
    </section>
  );
}
